import React from 'react';
import AppRoutes from './AppRoutes';
import './App.css';

function App() {
  return (
    <div>
      <AppRoutes />
    </div>
  );
}

export default App;
